window.$ = require( "jquery" );
window.Vue = require( "vue" );
window.Complex = require('complex.js');
window.Uuid = require('uuid');
require('eldarion-ajax');
// const MathJax = require('mathjax-full');
// const MathJax = require('mathjax/es5/tex-chtml-full.js');

var pending = {
    jQuery : true,
    MathJax : true
}

const K = {
    PI: Math.PI,
    sqrt2: Math.sqrt(2),
}

Complex.prototype.argPI = function() {
    return this.arg() / K.PI;
}

const C = {
    complexData(c) {
        return Complex(c);
    },
}

window.accessStat = {
    init() {
        if (localStorage.getItem("uuid")===null) {
            localStorage.setItem("uuid", Uuid.v4());
        }
        $.post("services/",{
            cmd: "access",
            uuid: localStorage.getItem("uuid"),
        });
    }
}

window.sliderHandler = {
    select(selector) {
        $(".slider").removeClass("active-slider").filter(selector || "none").addClass("active-slider");
    },
    init() {
        var sliderHandler = this;
        $(document).on('click', "[data-slider-select]", function(e) {
            sliderHandler.select($(e.target).data("sliderSelect"));
        }).on('click', ".close-slider", function(e) {
            sliderHandler.select();
        });
        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                sliderHandler.select();
            }
        });
    }
}

window.helpHandler = {
    // active: true,
    toggle() {
        // this.active = !this.active;
        localStorage.setItem("activeHelp", localStorage.getItem("activeHelp")==""?"on":"");
        $("#main-container").toggleClass("active-help");
    },
    init() {
        if (localStorage.getItem("activeHelp")===null) {
            localStorage.setItem("activeHelp", "on");
        }
        if (localStorage.getItem("activeHelp")!="") {
            $("#main-container").addClass("active-help");
        }
        var helpHandler = this;
        $(document).on('click', ".helper-control", function(e) {
            helpHandler.toggle();
        });
        $(document).on("mouseover", ".active-help div:has(> .help), div.active-help:has(> .help), .active-help [data-help-content]", function(e){
            var target = $(e.currentTarget);
            var $mainContainer = $("#main-container");
            var containerPos = $mainContainer.position();
            var containerW = $mainContainer.width();
            var containerH = $mainContainer.height();
            var spriteToTop = e.pageY > containerPos.top + containerH / 2;
            var spriteToLeft = e.pageX > containerPos.left + containerW / 2;
            var spritePosition = {};
            if (spriteToTop) {
                spritePosition.top = "unset";
                spritePosition.bottom = containerH - e.pageY + containerPos.top;
            } else {
                spritePosition.top = e.pageY - containerPos.top;
                spritePosition.bottom = "unset";
            }
            if (spriteToLeft) {
                spritePosition.left = "unset";
                spritePosition.right = containerW - e.pageX + containerPos.left;
            } else {
                spritePosition.left = e.pageX - containerPos.left;
                spritePosition.right = "unset";
            }
            var content = target.attr("data-help-content") || target.find(".help").html();
            $(".help-sprite").css(spritePosition).html(content).show();
        }).on("mouseout", "div:has(> .help), [data-help-content]", function(e){
            $(".help-sprite").hide();
        });
    },
};

// eldarion-ajax
$(document).on(`eldarion-ajax:begin`, function(evt, $el) {
    $("#main-container").addClass("busy");
});
$(document).on('eldarion-ajax:complete', function() {
    $("#main-container").removeClass("busy");
});
$(document).on('eldarion-ajax:error', function() {
    sliderHandler.select("#error");;
});
$(document).on('eldarion-ajax:success', function(evt, $el, data, textStatus, jqXHR) {
    if (data && data.errors) {
        sliderHandler.select("#error");
    }
    if (data && data.commands) {
        for (var i = 0; i < data.commands.length; i++) {
            var command = data.commands[i];
            switch (command) {
                case 'mail-sent':
                    sliderHandler.select("#thankyou");
                    $el && $el[0].reset();
                    break;
                default:
            }
        }
    }
});

// donate form
$(function(){
    $(document).on("click","#donate-trigger",function(){
        $("#donate-form").submit();
    })
});

$(function(){
    setInterval(function () {
        var h = document.documentElement.clientHeight;
        var w = document.documentElement.clientWidth;
        // Portrait / Landscape
        var newOrient = w*.75<h ? 'P' : 'L';
        if (window.orientation != newOrient) {
            window.orientation = newOrient;
            $("#main-container").removeClass("P L").addClass(newOrient);
        }
    }, 80);

    window.helpHandler.init();
    window.sliderHandler.init();
    window.accessStat.init();

    pending.jQuery = false;

})

MathJax = {
    loader: {
        load: ['[tex]/color','[tex]/cancel']
    },
    tex: {
        packages: {'[+]': ['cancel', 'color']},
        inlineMath: [['$', '$'], ['\\(', '\\)']]
    },
    startup: {
        pageReady() {
            return MathJax.startup.defaultPageReady().then(function () {
                pending.MathJax = false;
            });
        }
    }
}

var intervalId = setInterval(function(){
    var noPending = Object.values(pending).every(
        value => value === false
    );
    if (!noPending) {
        return;
    }

    window.vueApp = Vue.createApp({
        mounted() {
            // splash
            $(".splash1").animate({opacity:0}, 500, null, function(){
                $(".splash2").animate({opacity:0}, 1500, null, function(){
                    $(".splash3").animate({opacity:0}, 2000, null, function(){
                        $(".splash").remove();
                    })
                })
            })

        },
        data() { return {
            mode: "bloch",
            ltrGateDirection: true,
            currentInput: {
                alpha: {
                    abs: 1,
                    arg: 0 //K.PI/6
                },
                beta: {
                    abs: 0,
                    arg: 0
                },
            },
            gateChain: [
                {
                    "gate": "I",
                    "params": [ 0 ]
                },
            ],
            screens: [ 0, 1 ],
            gateList: {
                "I": {
                    label: "I",
                    description: "Identity",
                    matrix() { return [
                        [[1,0], [0,0]],
                        [[0,0], [1,0]]
                    ]}
                },
                "Ph": {
                    label: "Ph(δ)",
                    description: "Global phase",
                    matrix(params) { return [
                        [new Complex(0, params[0]*K.PI).exp(), [0,0]],
                        [[0,0], new Complex(0, params[0]*K.PI).exp()]
                    ]},
                    paramList: [
                        {
                            label: 'δ',
                            min: 0,
                            max: 2,
                            minLabel: "0",
                            maxLabel: "2π",
                        }
                    ],
                },
                "X": {
                    label: "X",
                    description: "Pauli X, NOT",
                    matrix() { return [
                        [[0,0], [1,0]],
                        [[1,0], [0,0]]
                    ]}
                },
                "Y": {
                    label: "Y",
                    description: "Pauli Y",
                    matrix() { return [
                        [[0,0], [0,-1]],
                        [[0,1], [0,0]]
                    ]}
                },
                "Z": {
                    label: "Z",
                    description: "Pauli Z",
                    matrix() { return [
                        [[1,0], [0,0]],
                        [[0,0], [-1,0]]
                    ]}
                },
                "S": {
                    label: "S",
                    description: "Phase gate S",
                    matrix() { return [
                        [[1,0], [0,0]],
                        [[0,0], [0,1]]
                    ]}
                },
                "V": {
                    label: "V",
                    description: "Square root of X",
                    matrix() { return [
                        [[.5,.5], [.5,-.5]],
                        [[.5,-.5], [.5,.5]]
                    ]}
                },
                "H": {
                    label: "H",
                    description: "Hadamard",
                    matrix() { return [
                        [[K.sqrt2/2,0], [K.sqrt2/2,0]],
                        [[K.sqrt2/2,0], [-K.sqrt2/2,0]]
                    ]}
                },
                "P": {
                    label: "P(φ)",
                    description: "Phase shift",
                    matrix(params) { return [
                        [[1,0], [0,0]],
                        [[0,0], new Complex(0, params[0]*K.PI).exp()]
                    ]},
                    paramList: [
                        {
                            label: 'φ',
                            min: 0,
                            max: 2,
                            minLabel: "0",
                            maxLabel: "2π",
                        }
                    ],
                },
                "T": {
                    label: "T",
                    description: "Phase gate T",
                    matrix(params) { return [
                        [[1,0], [0,0]],
                        [[0,0], new Complex(0, K.PI/4).exp()]
                    ]},
                },
                "Rx": {
                    label: "Rx(θ)",
                    description: "Rotation about x-axis",
                    matrix(params) { return [
                        [[Math.cos(params[0]*K.PI/2),0], [0,-Math.sin(params[0]*K.PI/2)]],
                        [[0,-Math.sin(params[0]*K.PI/2)], [Math.cos(params[0]*K.PI/2),0]]
                    ]},
                    paramList: [
                        {
                            label: 'θ',
                            min: -2,
                            max: 2,
                            minLabel: "-2π",
                            maxLabel: "2π",
                        }
                    ],
                },
                "Ry": {
                    label: "Ry(θ)",
                    description: "Rotation about y-axis",
                    matrix(params) { return [
                        [[Math.cos(params[0]*K.PI/2),0], [-Math.sin(params[0]*K.PI/2),0]],
                        [[Math.sin(params[0]*K.PI/2),0], [Math.cos(params[0]*K.PI/2),0]]
                    ]},
                    paramList: [
                        {
                            label: 'θ',
                            min: -2,
                            max: 2,
                            minLabel: "-2π",
                            maxLabel: "2π",
                        }
                    ],
                },
                "Rz": {
                    label: "Rz(θ)",
                    description: "Rotation about z-axis",
                    matrix(params) { return [
                        [new Complex(0,-params[0]*K.PI/2).exp(), [0,0]],
                        [[0,0], new Complex(0,params[0]*K.PI/2).exp()]
                    ]},
                    paramList: [
                        {
                            label: 'θ',
                            min: -2,
                            max: 2,
                            minLabel: "-2π",
                            maxLabel: "2π",
                        }
                    ],
                },
            }
        }},
        computed: {
            output() {
                return this.step(this.gateChain.length);
            },
            input() {
                return {
                    alpha: C.complexData(this.currentInput.alpha),
                    beta: C.complexData(this.currentInput.beta),
                }
            },
            composedGate() {
                return this.composedStepGate(this.gateChain.length);
            },
            allStepsWithLabels() {
                var all=[];
                for (index = 0; index < this.gateChain.length+1; index++) {
                    all.push({
                        alpha: this.step(index).alpha,
                        beta: this.step(index).beta,
                        label: this.stepLabel(index),
                        shortLabel: this.shortStepLabel(index),
                    });
                }
                return all;
            },
        },
        methods: {
            setScreen(screenIdx, step) {
                this.screens[screenIdx] = step;
            },
            stepLabel(n) {
                if (n==0) {
                    return "Input";
                }
                if (n==this.gateChain.length) {
                    return "Output";
                }
                return "Step "+n;
            },
            shortStepLabel(n) {
                if (n==0) {
                    return "IN";
                }
                if (n==this.gateChain.length) {
                    return "OUT";
                }
                return ""+n;
            },
            step(n) {
                var gate = this.composedStepGate(n);
                var psi = this.currentInput;
                var alpha = gate[0][0].mul(psi.alpha).add( gate[0][1].mul(psi.beta) );
                var beta = gate[1][0].mul(psi.alpha).add( gate[1][1].mul(psi.beta) );
                if (alpha.abs()>1) {
                    alpha = new Complex({abs:1, arg:alpha.arg()})
                }
                if (beta.abs()>1) {
                    beta = new Complex({abs:1, arg:beta.arg()})
                }
                return {
                    alpha: alpha,
                    beta: beta,
                }
            },
            composedStepGate(n) {
                var ret = [
                    [new Complex(1,0), new Complex(0,0)],
                    [new Complex(0,0), new Complex(1,0)]
                ];
                for (var i = this.gateChain.length - n; i < this.gateChain.length; i++) {
                    var cur = this.gateList[this.gateChain[i].gate].matrix(this.gateChain[i].params);
                    ret = [
                        [ret[0][0].mul(cur[0][0]).add( ret[0][1].mul(cur[1][0]) ) , ret[0][0].mul(cur[0][1]).add( ret[0][1].mul(cur[1][1]) )],
                        [ret[1][0].mul(cur[0][0]).add( ret[1][1].mul(cur[1][0]) ) , ret[1][0].mul(cur[0][1]).add( ret[1][1].mul(cur[1][1]) )],
                    ];
                }
                return ret;
            },
            reversedStepGate(n) {
                var gate = this.composedStepGate(n);
                var det = gate[0][0].mul(gate[1][1]).sub(  gate[0][1].mul(gate[1][0]) );
                var reversed = [
                    [ gate[1][1].div(det), gate[0][1].mul([-1,0]).div(det) ],
                    [ gate[1][0].mul([-1,0]).div(det), gate[0][0].div(det) ]
                ]
                return reversed;
            },
            remove(idx) {
                this.gateChain.splice(idx,1);
                //  keep screens on selected step
                for (var i = 0; i < this.screens.length; i++) {
                    if (this.screens[i] >= this.gateChain.length+1-idx) {
                        this.screens[i]--;
                    }
                }
            },
            add(idx) {
                this.gateChain.splice(idx,0,{
                    "gate": "I",
                    "params": [ 0 ]
                });
                //  keep screens on selected step
                for (var i = 0; i < this.screens.length; i++) {
                    if (this.screens[i] == 0) continue;
                    if (this.screens[i] >= this.gateChain.length-1-idx) {
                        this.screens[i]++;
                    }
                }
            },
            tryToSet(newC, target, fromStep) {
                if (fromStep === undefined) {
                    fromStep = 0;
                }
                var other = target=="alpha" ? "beta" : "alpha";
                var targetVal = new Complex(newC);
                var state = {};
                state[target] = {
                    abs: Math.min(1, targetVal.abs()),
                    arg: targetVal.arg()
                }
                state[other] = this.step(fromStep)[other];
                if (state[target].abs >= 1) {
                    state[other] = Complex.ZERO;
                } else {
                    var abs = Math.sqrt(Math.max(0,1-targetVal.abs()**2));
                    state[other] = new Complex({abs:abs, arg:state[other].arg()})
                }

                if (fromStep == 0) {
                    // input step
                    this.currentInput = state;
                } else {
                    var reversed = this.reversedStepGate(fromStep);
                    this.currentInput.alpha = reversed[0][0].mul(state.alpha).add( reversed[0][1].mul(state.beta) );
                    this.currentInput.beta = reversed[1][0].mul(state.alpha).add( reversed[1][1].mul(state.beta) );
                }
                // this.currentInput[other]
            },
        }
    });

    window.vueApp.component('qbit-text', {
        props: ["values", "editable"],
        template: '#qbit-text-template',
        methods: {
            pretty(n) {
                return Math.round(n*1000)/1000;
            }
        }
    });

    window.vueApp.component('qbit-cartesian', {
        template: '#qbit-cartesian-template',
        props: ["values", "editable"],
        data() {
            return {
                ticks: 0,
                scale: .4,
                moving: false,
                xStart: null,
                yStart: null,
                reStart: null,
                imStart: null,
            }
        },
        mounted() {
            // ticker
            var component = this;
            setInterval(function () {
                component.ticks = Math.floor(Date.now() / 1000);
            }, 1000);

            if (!this.editable) {
                return;
            }
            var app=this;
            $(window).on("mouseup touchend",function(){
                app.moving = false;
            });
            $(window).on("mousemove touchmove",function(e){
                if (!app.moving) {
                    return;
                }
                var curX = e.clientX || e.targetTouches && e.targetTouches.length && e.targetTouches[0].clientX;
                var curY = e.clientY || e.targetTouches && e.targetTouches.length && e.targetTouches[0].clientY;
                var squeareDim = $('.square1x1').find(".c-cartesian").width();
                var deltaX = (curX-app.xStart) / squeareDim / app.scale;
                var deltaY = -(curY-app.yStart) / squeareDim / app.scale;
                app.$emit('tryToSet', {
                    newC: { re: app.reStart+deltaX, im: app.imStart+deltaY },
                    index: app.moving
                });
            });app
        },
        computed: {
            orderedIdx() {
                if (this.ticks % 2) {
                    return Array.from(Object.keys(this.values));
                }
                return Array.from(Object.keys(this.values)).reverse();
            },
        },
        methods: {
            label(index) {
                switch (index) {
                    case "alpha":
                        return "α";
                        break;

                    case "beta":
                        return "β";
                        break;

                    default:
                        return "";
                        break;
                }
            },
            moveStart(index, e) {
                if (!this.editable || this.moving) {
                    return;
                }
                this.xStart = e.clientX || e.targetTouches && e.targetTouches.length && e.targetTouches[0].clientX,
                this.yStart = e.clientY || e.targetTouches && e.targetTouches.length && e.targetTouches[0].clientY,
                this.reStart = this.values[index].re;
                this.imStart = this.values[index].im;
                this.moving = index;
            },
        }
    });

    window.vueApp.component('qbit-bloch', {
        props: ["values"],
        template: '#qbit-bloch-template',
        data() {
            return {
                ticks: 0,
            }
        },
        mounted() {
            var component = this;
            setInterval(function() {
                component.ticks = Math.floor(Date.now()/1000);
            }, 1000);
        },
        computed: {
            orderedIdx() {
                if (this.ticks % 2) {
                    return Array.from(this.values.keys());
                }
                return Array.from(this.values.keys()).reverse();
            },
        },
        methods: {
            stepColor(idx) {
                return 'hsl(' + ((360 / (this.values.length-1) * idx)||0) + ',100%,27.3%)';
            },
            theta(idx) {
                return 2*Math.acos(this.values[idx].alpha.abs());
            },
            phi(idx) {
                return this.values[idx].beta.arg()-this.values[idx].alpha.arg();
            },
            x(idx) {
                return Math.cos(this.phi(idx))*Math.sin(this.theta(idx));
            },
            y(idx) {
                return Math.sin(this.phi(idx))*Math.sin(this.theta(idx));
            },
            z(idx) {
                return Math.cos(this.theta(idx));
            },
            projXsphere(idx) {
                return this.y(idx) - this.x(idx) / K.sqrt2/2;
            },
            projYsphere(idx) {
                return this.z(idx) - this.x(idx) / K.sqrt2/2;
            },
            projXplane(idx) {
                return this.projXsphere(idx);
            },
            projYplane(idx) {
                return this.projXsphere(idx) - this.y(idx);
                // return this.x(idx) / K.sqrt2/2;
            },

        }
    });

    vueApp.config.compilerOptions.isCustomElement = (tag) => {
        return tag.startsWith('mjx-') || ["mo", "mi", "mtable", "mrow", "mtd", "mtr", "mn", "math", "mover", "msqrt", "mtext", "mfrac", "mspace", "mstyle", "msup", "msub", "mroot"].includes(tag);
    }

    // ***********SETTINGS************
    var cssRoot = document.querySelector(':root');
    var cssRootStyle = getComputedStyle(cssRoot);
    vueApp.config.globalProperties.$config = {
        activeColor: cssRootStyle.getPropertyValue('--activeColor'),
        passiveColor: cssRootStyle.getPropertyValue('--passiveColor'),
        // log: window.console.log
    }
    // *******************************

    vueApp.mount('#main-container');

    clearInterval(intervalId);
}, 80);
